export default __webpack_public_path__ + "static/media/imgInfografia.7678e6e5.jpg";